import { AdminPageHeader } from '@/components/patterns/admin-page'
import { StockImageForm } from '@/components/stock-images/StockImageForm'
import { adminRouteTitleHead } from '@/lib/admin-route-title'
import { stockImagesQueries } from '@/lib/services/stock-images/stock-images.query'
import { useMerchandisingTagGroups } from '@/lib/services/merchandising-tags/merchandising-tags.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { ImagePlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/stock-images/create')({
  component: StockImageCreatePage,
  head: adminRouteTitleHead,
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('create', 'stock-images') ||
      !context.ability.can('access', 'global')
    ) {
      throw notFound()
    }

    await context.queryClient.ensureQueryData(
      stockImagesQueries.tags({ organizationId: params.orgId })
    )

    return { isReadOnly: false }
  },
})

export function StockImageCreatePage() {
  const { data: merchandisingTagGroups = [] } = useMerchandisingTagGroups()

  return (
    <div className="max-w-6xl space-y-5">
      <AdminPageHeader
        icon={ImagePlus}
        title="Create Stock Image"
        description="Upload a global image, add simple metadata, and tag it for florist filtering."
      />
      <StockImageForm mode="create" merchandisingTagGroups={merchandisingTagGroups} />
    </div>
  )
}
